import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '~/components/modals/Modal';
import useModal from '~/hooks/useModal';
import { useDuplicateGroupInTest } from '~/modules/tests/hooks/useDuplicateGroupInTest/useDuplicateGroupInTest';
import { isInternalServerError } from '~/services/api/utils';

interface CloneGroupModalProps {
  className?: string;
  id: string;
  testId: string;
}

const CloneGroupModal = ({ className, id, testId }: CloneGroupModalProps) => {
  const { t } = useTranslation();
  const modal = useModal();
  const [duplicateGroupInTest, duplicateRequestState] = useDuplicateGroupInTest();

  const handleCloneConfirm = useCallback(async () => {
    await duplicateGroupInTest({ id, testId });
    modal.hide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duplicateGroupInTest, id, modal.hide, testId]);

  return (
    <ConfirmModal
      className={className}
      title={t('cloneGroupModal.title', 'Do you want to duplicate this group?')}
      pending={duplicateRequestState.isLoading}
      hasInternalServerError={isInternalServerError(duplicateRequestState.error)}
      onConfirm={handleCloneConfirm}
      onCancel={modal.hide}
    />
  );
};

export default CloneGroupModal;
